export default "__VITE_ASSET__NsxiacYa__"